import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { hasRole, isPricePostingUsaProSubmittedByPriceCoherence, isAdminNotConsultant } from "@/js/http/auth.js";
import * as orderHandler from "@/js/order/order.js";
import ThirdPartyUserSelector from "@/components/order/TargetSelector/ThirdPartyUserSelector.vue";
import PricePostingUsaProSelector from "@/components/order/TargetSelector/PricePostingUsaProSelector.vue";
export default {
  name: "TargetSelectors",
  components: {
    ThirdPartyUserSelector: ThirdPartyUserSelector,
    PricePostingUsaProSelector: PricePostingUsaProSelector
  },
  props: {
    loggedUserData: Object,
    thirdPartyContainerClass: {
      type: String,
      default: null
    },
    pricePostingContainerClass: {
      type: String,
      default: null
    },
    pricePostingDisabledIfCartInProgress: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      hasRoleThirdParty: false,
      isCartInProgress: false,
      pricePostingUsa: {
        canChoose: false,
        mustChoose: false,
        label: ""
      }
    };
  },
  computed: {},
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var thirdPartyUserSelected, pricePostingSelected;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.hasRoleThirdParty = hasRole(process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER);
            _this.pricePostingUsa.canChoose = _this.hasRoleThirdParty || isPricePostingUsaProSubmittedByPriceCoherence(_this.loggedUserData);
            _context.next = 4;
            return _this.updateCartStatus();
          case 4:
            if (!_this.pricePostingUsa.canChoose) {
              _context.next = 17;
              break;
            }
            _this.pricePostingUsa.label = "Estimated delivery month";
            if (_this.hasRoleThirdParty) {
              thirdPartyUserSelected = orderHandler.getThirdPartyUserSelected();
              _this.pricePostingUsa.mustChoose = !!(thirdPartyUserSelected !== null && thirdPartyUserSelected !== void 0 && thirdPartyUserSelected.isPricePostingUsaProSubmittedByPriceCoherence);
            } else {
              _this.pricePostingUsa.mustChoose = isPricePostingUsaProSubmittedByPriceCoherence(_this.loggedUserData);
            }
            pricePostingSelected = orderHandler.getPricePostingUsaSelected();
            if (!(_this.pricePostingUsa.mustChoose && pricePostingSelected === null)) {
              _context.next = 13;
              break;
            }
            _context.next = 11;
            return _this.$refs.pricePostingUsaProSelector.selectDefaultValue();
          case 11:
            _context.next = 15;
            break;
          case 13:
            _context.next = 15;
            return _this.$refs.pricePostingUsaProSelector.checkPricePostingSelected();
          case 15:
            _context.next = 18;
            break;
          case 17:
            orderHandler.removePricePostingUsaLocale();
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    changeThirdPartyUserSelected: function changeThirdPartyUserSelected() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var thirdPartyUserSelected, pricePostingUsaWasShown, currentCart, hasCart, _currentCart$pricePos, pricePostingIdOfCart, hasValueAvailable, defaultValue, _this2$$refs$pricePos, _this2$$refs$pricePos2;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.$emit("changeThirdPartyUserSelected");
              thirdPartyUserSelected = orderHandler.getThirdPartyUserSelected();
              pricePostingUsaWasShown = _this2.pricePostingUsa.mustChoose;
              _this2.pricePostingUsa.mustChoose = thirdPartyUserSelected === null || thirdPartyUserSelected === void 0 ? void 0 : thirdPartyUserSelected.isPricePostingUsaProSubmittedByPriceCoherence;
              currentCart = orderHandler.getCurrentOrder();
              hasCart = (currentCart === null || currentCart === void 0 ? void 0 : currentCart.id_order) > 0;
              if (!hasCart) {
                _context2.next = 30;
                break;
              }
              if (_this2.pricePostingUsa.mustChoose) {
                _context2.next = 12;
                break;
              }
              _context2.next = 10;
              return _this2.$refs.pricePostingUsaProSelector.resetToNull();
            case 10:
              _context2.next = 28;
              break;
            case 12:
              pricePostingIdOfCart = ((_currentCart$pricePos = currentCart.pricePostingUsaPro) === null || _currentCart$pricePos === void 0 ? void 0 : _currentCart$pricePos.id) > 0 ? +currentCart.pricePostingUsaPro.id : 0;
              _context2.next = 15;
              return _this2.$refs.pricePostingUsaProSelector.hasValueAvailable(pricePostingIdOfCart);
            case 15:
              hasValueAvailable = _context2.sent;
              if (!hasValueAvailable) {
                _context2.next = 20;
                break;
              }
              _this2.$refs.pricePostingUsaProSelector.setValue(pricePostingIdOfCart);
              _context2.next = 28;
              break;
            case 20:
              _context2.next = 22;
              return _this2.$refs.pricePostingUsaProSelector.getDefaultValue();
            case 22:
              defaultValue = _context2.sent;
              _context2.next = 25;
              return orderHandler.changeOrderPricePosting(defaultValue.id, +currentCart.id_order);
            case 25:
              _this2.$refs.pricePostingUsaProSelector.selectDefaultValue();
              _context2.next = 28;
              return orderHandler.fetchBasket();
            case 28:
              _context2.next = 38;
              break;
            case 30:
              if (_this2.pricePostingUsa.mustChoose) {
                _context2.next = 35;
                break;
              }
              _context2.next = 33;
              return (_this2$$refs$pricePos = _this2.$refs.pricePostingUsaProSelector) === null || _this2$$refs$pricePos === void 0 ? void 0 : _this2$$refs$pricePos.resetToNull();
            case 33:
              _context2.next = 38;
              break;
            case 35:
              if (!_this2.pricePostingUsa.mustChoose) {
                _context2.next = 38;
                break;
              }
              _context2.next = 38;
              return (_this2$$refs$pricePos2 = _this2.$refs.pricePostingUsaProSelector) === null || _this2$$refs$pricePos2 === void 0 ? void 0 : _this2$$refs$pricePos2.selectDefaultValue();
            case 38:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    changePricePostingSelected: function changePricePostingSelected() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.$emit("changePricePostingSelected");
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    updateCartStatus: function updateCartStatus() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var currentOrder, hasItems;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              currentOrder = orderHandler.getCurrentOrder();
              hasItems = currentOrder != null && Array.isArray(currentOrder.items) && currentOrder.items.length > 0;
              _this4.isCartInProgress = hasItems;
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    isAdminNotConsultant: isAdminNotConsultant
  },
  mounted: function mounted() {
    this.$EventBus.$on("BasketRemoved", this.updateCartStatus);
    this.$EventBus.$on("ItemRemoved", this.updateCartStatus);
    this.$EventBus.$on("add-item-to-cart", this.updateCartStatus);
    this.$EventBus.$on("update-cart", this.updateCartStatus);
  }
};